<template>
  <div></div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'SigninSuccessPage',

  computed: {
    ...mapState('user', ['user'])
  },

  mounted() {
    window?.datafast('signin-completed')

    if (this.user.isPremium) {
      if (this.user.quizString) {
        this.$router.push({ name: 'hub' })
      } else {
        this.$router.push({ name: 'onboarding' })
      }
    } else {
      if (this.$route.params.plan) {
        this.openCheckout(this.$route.params.plan)
      } else {
        this.$router.push({ name: 'onboarding' })
      }
    }
  },

  methods: {
    ...mapActions('payments', {
      openCheckout: 'OPEN_CHECKOUT'
    })
  }
}
</script>
